// Generated by ReScript, PLEASE EDIT WITH CARE


function applyPayload(t, entry) {
  let response = entry.response;
  if (response === undefined) {
    return;
  }
  let final = entry.final;
  if (final !== undefined) {
    t.next(response);
    if (final) {
      t.complete();
      return;
    } else {
      return;
    }
  }
}

let RelayReplaySubject = {
  applyPayload: applyPayload
};

export {
  RelayReplaySubject,
}
/* No side effect */
